import React from 'react';
import { Reveal } from '../Reveal';
import { Button } from '../Button';
import { results } from '../../data/study';
import { useLayout } from '../../contexts/LayoutContext';
type PopulationScreenProps = {
  onNext: () => void;
};
export function PopulationScreen({
  onNext
}: PopulationScreenProps) {
  const {
    compact
  } = useLayout();
  return <div className={`flex min-h-full flex-col ${compact ? 'py-6 pt-12' : 'justify-center py-10'}`} data-id="element-120" data-mp="21szwhjoha2g9">
      <Reveal data-id="element-121" data-mp="25ulhxtf2vp22">
        <p className={`font-display font-light leading-none tracking-[-0.05em] tabular-nums text-ink ${compact ? 'text-[6.5rem]' : 'text-[11.5rem]'}`} data-id="element-122" data-mp="25utrbbbzsc8i">
          {results.backgroundAntifibroticPct}
          <span className="text-[0.45em] text-accent" data-id="element-123" data-mp="2kkixjkyxz6fn">%</span>
        </p>
      </Reveal>
      <Reveal delay={0.1} data-id="element-124" data-mp="2plgexvc4nwg3">
        <p className={`mt-5 max-w-xl leading-relaxed text-muted ${compact ? 'text-lg' : 'text-xl'}`} data-id="element-125" data-mp="2plymvp85jz3u">
          of patients were already receiving nintedanib or pirfenidone
        </p>
      </Reveal>
      <Reveal delay={0.7} data-id="element-126" data-mp="ks02925brv6f">
        <p className={`max-w-3xl border-l-2 border-accent-fill font-display font-light tracking-[-0.02em] text-ink ${compact ? 'mt-10 pl-5 text-[1.5rem] leading-snug' : 'mt-14 pl-6 text-[2.1rem] leading-snug'}`} data-id="element-127" data-mp="kp5hf9ieg8ch">
          Even in a population largely receiving existing antifibrotic therapy, lung function continued to decline.
        </p>
      </Reveal>
      <Reveal delay={0.9} className={compact ? 'mt-auto pt-10' : 'mt-12'} data-id="element-128" data-mp="13jspefxpqm68">
        <Button fullWidth={compact} onClick={onNext} data-id="element-129" data-mp="yj51i34s6lg8">
          Why might this matter?
        </Button>
      </Reveal>
    </div>;
}